import { render, staticRenderFns } from "./RequestService.vue?vue&type=template&id=68d82bc0&scoped=true"
import script from "./RequestService.vue?vue&type=script&lang=js"
export * from "./RequestService.vue?vue&type=script&lang=js"
import style0 from "./RequestService.vue?vue&type=style&index=0&id=68d82bc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d82bc0",
  null
  
)

export default component.exports